import { Link } from "react-router-dom";
import { Phone, Sparkles, Brush, Truck, Key, Building2, HardHat, ChefHat } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { track } from "@/lib/api";

export const SERVICE_ICONS = { sparkles: Sparkles, brush: Brush, truck: Truck, key: Key, building: Building2, "hard-hat": HardHat, "chef-hat": ChefHat };

export const useServiceGroups = () => {
  const { catalog } = useSettings();
  const all = (catalog?.service_types || []).filter((s) => s.active !== false);
  return { online: all.filter((s) => (s.mode || "online") === "online"), callOnly: all.filter((s) => s.mode === "call_only") };
};

export const CallForQuoteButton = ({ service, className = "btn-primary", testId }) => {
  const { settings } = useSettings();
  const tel = (settings?.phone || "").replace(/[^\d+]/g, "");
  const label = service?.cta_label || "CALL FOR QUOTE";
  if (!tel) return <Link to="/contact" className={className} data-testid={testId} onClick={() => track("call_for_quote_clicked", { source: service?.code })}><Phone className="w-4 h-4" /> {label}</Link>;
  return <a href={`tel:${tel}`} className={className} data-testid={testId} onClick={() => track("call_for_quote_clicked", { source: service?.code })}><Phone className="w-4 h-4" /> {label}</a>;
};

export const CallOnlyCard = ({ s }) => {
  const Icon = SERVICE_ICONS[s.icon] || Sparkles;
  return (
    <article className="kc-card p-6 flex flex-col" data-testid={`call-only-card-${s.code}`}>
      <span className="h-11 w-11 rounded-full bg-[#F3F1EC] grid place-items-center"><Icon className="w-5 h-5 text-[var(--kc-terracotta)]" /></span>
      <h3 className="mt-4 text-lg font-semibold uppercase tracking-wide">{s.name}</h3>
      <p className="mt-2 text-sm text-[#5A606A] leading-relaxed flex-1">{s.short_description}</p>
      <p className="mt-4 inline-flex w-fit items-center rounded-full bg-[#FFFAEB] text-[#B54708] px-3 h-7 text-xs font-semibold tracking-wide" data-testid={`call-only-badge-${s.code}`}>CUSTOM QUOTE REQUIRED</p>
      <CallForQuoteButton service={s} className="btn-primary mt-4 w-full" testId={`call-for-quote-${s.code}`} />
    </article>
  );
};

export const TrustCounter = ({ className = "" }) => {
  const { settings } = useSettings();
  if (!settings || settings.completed_services_visible === false) return null;
  const n = settings.completed_services_count ?? 70;
  const fmt = settings.completed_services_format || "plus";
  const value = fmt === "custom" && settings.completed_services_custom_text ? settings.completed_services_custom_text : fmt === "exact" ? String(n) : `${n}+`;
  return (
    <div className={`inline-flex items-center gap-4 rounded-2xl bg-white border border-[#E5E2DA] px-5 py-3 shadow-sm ${className}`} data-testid="trust-counter">
      <span className="font-display text-3xl sm:text-4xl font-semibold text-[var(--kc-blue)]" data-testid="trust-counter-value">{value}</span>
      <span className="text-sm font-medium leading-tight text-[var(--kc-text)]">Cleaning Services<br />Completed</span>
    </div>
  );
};
